import moment from 'moment'

export const fromNow = timestamp => moment(timestamp).fromNow()

export const dayOf = timestamp => moment(timestamp).format('MMM D, YYYY')
